"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ColorDropdown_1 = require("../colorDropdown/ColorDropdown");
var ColoredItemContent = /** @class */ (function (_super) {
    tslib_1.__extends(ColoredItemContent, _super);
    function ColoredItemContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColoredItemContent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: this.getClassName() },
            react_1.default.createElement("div", { className: this.getIconStyle(), style: { backgroundColor: this.getBackgroundColor() } }),
            react_1.default.createElement("span", null, this.props.text)));
    };
    ColoredItemContent.prototype.getIconStyle = function () {
        var _a = this.props.color, r = _a.r, g = _a.g, b = _a.b;
        var iconStyle = this.props.position === ColorDropdown_1.IconPosition.Right ? "gd-icon-navigateright" : "gd-icon-navigatedown";
        var iconSelector = "s-color-" + r + "-" + g + "-" + b;
        return "gd-color-config-item-sample " + iconStyle + " " + iconSelector;
    };
    ColoredItemContent.prototype.getClassName = function () {
        return classnames_1.default("gd-list-item gd-color-config-list-item s-colored-items-list-item", {
            "is-active": this.props.isSelected,
        });
    };
    ColoredItemContent.prototype.getBackgroundColor = function () {
        var _a = this.props.color, r = _a.r, g = _a.g, b = _a.b;
        return "rgba(" + r + "," + g + "," + b + ",1)";
    };
    return ColoredItemContent;
}(react_1.default.PureComponent));
exports.default = ColoredItemContent;
//# sourceMappingURL=ColoredItemContent.js.map